import { render, staticRenderFns } from "./informatiestromen.vue?vue&type=template&id=684537c8&scoped=true"
import script from "./informatiestromen.vue?vue&type=script&lang=js"
export * from "./informatiestromen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684537c8",
  null
  
)

export default component.exports